// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"754f1f7d","161":"3f3291d6","355":"0ca47c29","914":"8b0e96cf"}[chunkId] + ".js";
};